import {css} from '@emotion/css';

const styles = {
  container: css`
    label: avatar__container;
    width: 10rem;
    height: 10rem;
    overflow: hidden;
    border-radius: 50%;
    mask-image: radial-gradient(white, black);
  `,
  image: css`
    label: avatar__image;
    width: 100%;
    height: 100%;
  `,
};

export default styles;
